import { Container } from "@mui/material";
import { Link } from "react-router-dom";
import { StyledTherapyOptionsContainer, StyledTherapyOptionButton } from "./index.styles";

const therapyOptions = [
  {
    name: "Generalized Anxiety Disorder",
    url: "/treatment/generalized-anxiety-disorder",
  },
  {
    name: "Insomnia",
    url: "/treatment/insomnia",
  },
  {
    name: "Social Anxiety Disorder",
    url: "/treatment/social-anxiety-disorder",
  },
  {
    name: "Depression",
    url: "/treatment/depression",
  },
  {
    name: "Treatment Resistant Depression",
    url: "/treatment/treatment-resistant-depression",
  },
  {
    name: "Bipolar Disorder",
    url: "/treatment/bipolar-disorder",
  },
  {
    name: "Post Traumatic Stress Disorder",
    url: "/treatment/post-traumatic-stress-disorder",
  },
  {
    name: "Attention Deficit Hyperactivity Disorder",
    url: "/treatment/attention-deficit-hyperactivity-disorder",
  },
  {
    name: "Obsessive Compulsive Disorder",
    url: "/treatment/obsessive-compulsive-disorder",
  },
  {
    name: "Panic Disorder",
    url: "/treatment/panic-disorder",
  },
];

const TherapyOptions = ({ cssProps, colorWrapper }) => {
  return (
    <Container sx={{ padding: "0px !important", ...cssProps }}>
      <StyledTherapyOptionsContainer>
        {therapyOptions.map((option) => (
          <StyledTherapyOptionButton
            key={option.name}
            component={Link}
            to={option.url}
            variant="outlined"
            color={colorWrapper ? "accent" : "primary"}
            aria-label={`Learn more about ${option.name} treatment`}
          >
            {option.name}
          </StyledTherapyOptionButton>
        ))}
      </StyledTherapyOptionsContainer>
    </Container>
  );
};

export default TherapyOptions;
